import { FC, ReactNode } from "react";
import { useCallbackOnce } from "src/utils/hooks/useCallbackOnce";
import i18nService from "src/i18n/i18n-service";

interface ApplyLocaleRedirectHookProps {
  children: ReactNode;
}

const ApplyLocaleRedirectHook: FC<ApplyLocaleRedirectHookProps> = ({
  children,
}) => {
  useCallbackOnce(() => i18nService.verifyUserIsInCorrectLocale());

  return <>{children}</>;
};

export default ApplyLocaleRedirectHook;
